import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { Logo } from "./Logo";

export const NAV = [
  { label: "Əsas səhifə", to: "/", id: "home" },
  { label: "Layihələr", to: "/#projects", id: "projects" },
  { label: "Xidmətlər", to: "/#services", id: "services" },
  { label: "Qiymət", to: "/#calculator", id: "calculator" },
  { label: "Həll tap", to: "/advisor", id: "advisor", badge: true },
  { label: "Haqqımızda", to: "/#about", id: "about" },
  { label: "Əlaqə", to: "/#contact", id: "contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 20);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  useEffect(() => setOpen(false), [pathname, hash]);

  const isActive = (n) => (n.id === "advisor" ? pathname.startsWith("/advisor") : n.id === "home" ? pathname === "/" && !hash : hash === `#${n.id}`);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow] duration-300 ${scrolled || open ? "bg-[#F7F3EB]/90 backdrop-blur-md shadow-[0_1px_0_rgba(23,23,21,.08)]" : "bg-[#F7F3EB]/75 backdrop-blur-sm shadow-[0_1px_0_rgba(23,23,21,.06)]"}`}
    >
      <div className="container-lm flex h-[76px] items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8 xl:gap-11" aria-label="Əsas menyu">
          {NAV.map((n) => (
            <Link key={n.id} to={n.to} data-testid={`nav-${n.id}`} className={`nav-link ${isActive(n) ? "active" : ""}`}>
              {n.label}{n.badge && <span className="ml-1.5 align-middle rounded-full bg-[#D6AD62] text-[#171715] text-[9px] font-bold px-1.5 py-0.5">YENİ</span>}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/#contact" data-testid="header-contact-btn" className="btn-dark max-sm:!hidden !py-2.5">
            Bizimlə əlaqə <ArrowRight size={16} className="arr" />
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            aria-label={open ? "Menyunu bağla" : "Menyunu aç"}
            aria-expanded={open}
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden w-11 h-11 rounded-full border border-[#171715]/20 flex items-center justify-center bg-white/50"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="lg:hidden border-t border-[#171715]/10 bg-[#F7F3EB]" aria-label="Mobil menyu">
          <div className="container-lm py-4 flex flex-col">
            {NAV.map((n) => (
              <Link key={n.id} to={n.to} data-testid={`mobile-nav-${n.id}`} className="py-3 text-lg font-display font-semibold border-b border-[#171715]/5">
                {n.label}
              </Link>
            ))}
            <Link to="/#contact" data-testid="mobile-contact-btn" className="btn-dark mt-5 self-start">
              Bizimlə əlaqə <ArrowRight size={16} />
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
